import type { DocMigration } from "../docMigration";

// replace original note annotation positioningMethod with textPositioningMethod
function migrateElement(element: any): void {
  if (element.textPositioningMethod) {
    element.placementXAnchor = element.textPositioningMethod;
    delete element.textPositioningMethod;
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_412: DocMigration = {
  maxSchemaVersion: "0.0.412",
  description: "Renaming note textPositioningMethod to placementXAnchor",
  apply(json: any) {
    for (const annotationKey in json.annotation) {
      migrateElement(json.annotation[annotationKey]);
    }

    for (const settingsKey in json.settings) {
      const settings = json.settings[settingsKey];
      if (settings.type === "ANNOTATION_CATALOG_SETTINGS") {
        for (const annotationTemplateKey in settings.annotationTemplates) {
          const annotationTemplate = settings.annotationTemplates[annotationTemplateKey];
          for (const componentKey in annotationTemplate.components) {
            const component = annotationTemplate.components[componentKey];
            if (component.type === "NOTE") {
              migrateElement(component);
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_412;
